<div class="row">
  <div class="col-md-1 col-md-offset-11">
    <button mat-button (click)="handleRefreshRides()" id="ride-tracking-button-refresh">
      <mat-icon>refresh</mat-icon>&nbsp;&nbsp;Refresh
    </button>
  </div>
</div>

<mat-tab-group
  (selectedTabChange)="handleChangeTab($event)"
  [selectedIndex]="getTabOrdinalFromName(currentTab$ | async)"
  mat-stretch-tabs="false"
>
  <mat-tab [label]="tabs.PENDING"> </mat-tab>
  <mat-tab [label]="tabs.ACTIVE"> </mat-tab>
  <mat-tab [label]="tabs.CANCELLED"> </mat-tab>
</mat-tab-group>
<ng-container *ngIf="(currentTab$ | async) !== tabs.CANCELLED">
  <span>Filter By: </span>
  <mat-form-field *ngIf="(currentTab$ | async) === tabs.ACTIVE" appearance="outline">
    <mat-select id="rideTracking-select-status" placeholder="Status" [formControl]="statusSelector" multiple [compareWith]="compareIds">
      <mat-option
        id="rideTracking-statusOption-{{ status.name | camelCase }}"
        *ngFor="let status of reservationStatuses$ | async"
        [value]="status"
        [ngClass]="status.name | kabobCase"
      >
        {{ status.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <uz-transit-program-select
    [value]="selectedTransitProgramIds$ | async"
    (selectTransitProgram)="handleTransitProgramSelection($event)"
    [allowMultiSelect]="true"
  ></uz-transit-program-select>
  <uz-vehicle-type-filter
    *appRequiresPermissions="{ any: ['vehicle_read'] }"
    [vehicleType]="selectedVehicleTypeIds$ | async"
    (vehicleTypeSelected)="handleVehicleTypeSelection($event)"
    [allowMultiSelect]="true"
  ></uz-vehicle-type-filter>
</ng-container>
<app-generic-list
  id="rideTracking-genericList-ridesList"
  [testingIdAccessor]="['rideRequestId']"
  [dataItems]="rides$ | async"
  [columns]="columns"
  [paginationEnabled]="true"
  [paginationLength]="10000"
  [pageSize]="pageSize$ | async"
  [pageIndex]="pageNumber$ | async"
  [pageSizeOptions]="[20]"
  [shouldShowLoader]="loading$ | async"
  [enableStatusColors]="true"
  (paginationChangeHandler)="handlePageRides($event)"
  (itemSelectedHandler)="handleShowDetails($event)"
  data-private
></app-generic-list>
